var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"result-msg"},[_c('div',{staticClass:"result-msg-img"},[_vm._t("icon",function(){return [_c('img',{attrs:{"src":require("../../assets/images/ico_denglu.png")}})]})],2),_vm._v(" "),_c('div',{staticClass:"result-info"},[_vm._t("default",function(){return [_vm._v("暂无数据")]})],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-77501d2e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/basic/result.msg.vue
// module id = J2y5
// module chunks = 29